<template>
  <div id="selectDatasetsWrapper">
    <loading-notification
      v-if="!datasets"
      message="Er wordt gezocht naar beschikbare datasets">
    </loading-notification>

    <template v-else>
      <template v-if="hasUnknownValues">
        <div class="notification is-warning">
          <p><strong>Er zijn waardes die zich niet in de basislijst van deze bundel bevinden.</strong></p>
          <p>Deze zijn gemarkeerd in de onderstaande tabel met <span class="icon"><i class="fas fa-exclamation-triangle"></i></span>. Je kunt er voor kiezen deze waardes te laten toevoegen aan de basislijst tijdens het importeren of te negeren.</p>
          <p>Als de waardes worden genegeerd dan worden deze in de tabel vervangen door lege velden. Dit kan betekenen dat regels in hun geheel verdwijnen omdat ze identiek zijn geworden of conflicteren met regels die al in de tabel staan.</p>
        </div>

        <div class="field">
          <input
            id="switchColorSuccess"
            type="checkbox"
            name="switchColorSuccess"
            class="switch is-success"
            checked="checked"
            v-model="withNewValues">

          <label for="switchColorSuccess">Nieuwe waardes {{ withNewValues ? 'opslaan' : 'negeren' }}</label>
        </div>
      </template>

      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th
              v-for="column in columns"
              :key="column.column.id">

              {{ column.column.name }}
            </th>
          </tr>
        </thead>

        <tbody>
          <select-dataset-row
            v-for="dataset in datasets"
            :key="dataset.id"
            :dataset="dataset">
          </select-dataset-row>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script>
import mtka from 'mitsuketa'
import { mapGetters } from 'vuex'
import SelectDatasetRow from '@/components/datasets/SelectDatasetRow'
import LoadingNotification from '@/components/modules/LoadingNotification'

export default {
  name: 'SelectDatasets',
  components: {
    SelectDatasetRow,
    LoadingNotification
  },
  props: [
    'isActive'
  ],
  data () {
    return {
      withNewValues: false
    }
  },
  watch: {
    withNewValues () {
      this.$emit('selectdatasets:changed', { key: 'withNewValues', value: this.withNewValues })
    }
  },
  computed: {
    ...mapGetters({
      table: 'tables/table',
      columns: 'columns/columns',
      datasets: 'datasets/importables'
    }),
    hasUnknownValues () {
      return mtka.foundFalsy(this.datasets, { 'exists': false })
    }
  },
  methods: {
    getValue (columnId, dataset) {
      let column = dataset[dataset.findIndex(x => x.column_id === columnId)]
      return (column) ? column.value.value : null
    }
  }
}
</script>
